import { assign, createActor, setup } from "xstate";

// === Context ===

export interface ProtocolContext {
  selectedCode: string | null;
  saving: boolean;
  procedureDirty: Record<string, boolean>;
  procedureSaved: Record<string, boolean>;
}

const initialContext: ProtocolContext = {
  selectedCode: null,
  saving: false,
  procedureDirty: {},
  procedureSaved: {},
};

// === Events ===

type ProtocolEvents =
  | { type: "protocol.selectCode"; code: string | null }
  | { type: "protocol.saving" }
  | { type: "protocol.saved" }
  | { type: "protocol.reset" }
  | { type: "procedure.dirty"; code: string }
  | { type: "procedure.saved"; code: string };

// === Machine ===

export const encounterProtocolMachine = setup({
  types: {
    context: {} as ProtocolContext,
    events: {} as ProtocolEvents,
  },
}).createMachine({
  id: "encounterProtocol",
  initial: "active",
  context: initialContext,
  states: {
    active: {
      on: {
        "protocol.selectCode": {
          actions: assign(({ event }) => ({ selectedCode: event.code })),
        },
        "procedure.dirty": {
          actions: assign(({ context, event }) => ({
            procedureDirty: { ...context.procedureDirty, [event.code]: true },
          })),
        },
        "procedure.saved": {
          actions: assign(({ context, event }) => ({
            procedureDirty: { ...context.procedureDirty, [event.code]: false },
            procedureSaved: { ...context.procedureSaved, [event.code]: true },
          })),
        },
        "protocol.saving": {
          actions: assign({ saving: true }),
        },
        "protocol.saved": {
          actions: assign({ saving: false }),
        },
        "protocol.reset": {
          actions: assign(() => ({ ...initialContext })),
        },
      },
    },
  },
});

export const encounterProtocolActor = createActor(encounterProtocolMachine).start();
